// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_3bQC0ZqAqI"};
    if(module.hot) {
      // 1614934740205
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  